import React from 'react';
import { getLabel } from '../../../data/labels';
import { formatDate } from '../../utils/formatDate';
import { getConfiguration } from '../../utils/configuration';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import DetailedBalanceCss from './common-includes/DetailedBalanceCss';
import DetailedBalanceFooter from './common-includes/DetailedBalanceFooter';
import ShopReceiptFooter from './common-includes/ShopReceiptFooter';
import ShopReceiptHeader from './common-includes/ShopReceiptHeader';


function PosBalanceReport(props){
	
	const opData = props.data;
	const conf = getConfiguration();
	const fromTo = [getLabel('retail.from'), formatDate(opData.fromDate, false).formatted_no_hour, getLabel('retail.to'), formatDate(opData.toDate, false).formatted_no_hour].join(" ");
	//const reportingAmount = opData.body.total - opData.creditDebit.credit + opData.creditDebit.debit;
	const reportingAmount = opData.body.total + opData.creditDebit.credit - opData.creditDebit.debit;
	return <>
		<DetailedBalanceCss />
		<body>
			<ShopReceiptHeader customerLogo={props.customerLogo} aamsLogo={props.aamsLogo} operationTitle={getLabel('retail.pos_balance_report') + ' ' + opData.operator.shopDescr}></ShopReceiptHeader>	
			<div> {fromTo.toUpperCase()} </div>
			<div> {getLabel('retail.shop_detailed_balance.pos_id')}: {opData.operator.shopId} </div>
			<DetailedBalanceFooter footer={opData.body} />	
			<ShopReceiptFooter></ShopReceiptFooter>
			<div className="footerBox">
				<div className="operationMonospace "> 
					{getLabel('retail.pos_balance_report.credit_from')}: 
					{getCurrencyValue(opData.creditDebit.credit, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
				<div className="operationMonospace "> 
					{getLabel('retail.pos_balance_report.debit_to')}: 
					{getCurrencyValue(opData.creditDebit.debit, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
				<div className="operationMonospace "> 
					{getLabel('retail.pos_balance_report.reporting_amount')}: 
					{/*getCurrencyValue(opData.body.total, conf.cs.m, conf.cs.nd, conf.cs.ct)*/}
					{getCurrencyValue(reportingAmount, conf.cs.m, conf.cs.nd, conf.cs.ct)} 
				</div>
			</div>
		
		</body>
		
    </>;
}
export default PosBalanceReport;